"use client";

import NewsImage from "../../../assets/images/news.png";
import { withLocaleInURI } from "../../../internationalization/i18nURI";
import { useStores } from "../../../stores/useStores";
import { SchoolFeedMobileWidgetLink } from "../SchoolFeedMobileWidgetLink";
import { getQueries } from "../../../utils/SchoolBlocksUtilities";

export function MobileNewsWidgetLink(props: { active: boolean }) {
  const { i18nStore, interfaceStore } = useStores();
  const query = getQueries(interfaceStore.currentFullUrl);

  return (
    <SchoolFeedMobileWidgetLink
      href={{
        pathname: withLocaleInURI("/", i18nStore.currentAppSupportedLocale),
        query,
      }}
      active={props.active}
      src={NewsImage}
      text={"Topics"}
      color={"orange"}
    />
  );
}
